import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import workSpaces from 'modules/space_control/store/collections/workSpaces'
import type WorkSpace from 'modules/space_control/store/models/WorkSpace'

interface IWorkArea {
  id: string
  name: string
  location_id: string
  archived_at: string | null
  created_at?: string
  updated_at?: string
}

class WorkArea extends Model<IWorkArea> {
  static urlRoot() {
    return '/locations/work_areas'
  }

  constructor(attr: IWorkArea) {
    super(attr)

    makeObservable(this, {
      name: computed,
      archiveUrl: computed,
      unarchiveUrl: computed,
      isArchived: computed,
      workSpaces: computed,
    })
  }

  get id(): string {
    return this.attributes.id
  }

  get name(): string {
    return this.attributes.name
  }

  get archiveUrl(): string {
    return `/locations/work_areas/${this.attributes.id}/archive`
  }

  get unarchiveUrl(): string {
    return `/locations/work_areas/${this.attributes.id}/unarchive`
  }

  get workSpaces(): WorkSpace[] {
    return workSpaces.filter({ work_area_id: this.attributes.id, deleted_at: null })
  }

  get isArchived(): boolean {
    return !!this.attributes.archived_at
  }
}

export default WorkArea
